import Vue from 'vue';
import Vuex from 'vuex';
import { User } from '@/core/entity';

Vue.use(Vuex);

interface RootState {
  user: User | null;
}

export default new Vuex.Store<RootState>({
  state: {
    user: null,
  },
  mutations: {
    setUser(state, user: User | null) {
      state.user = user;
    }
  },
  actions: {

  },
});
